module.exports = __webpack_public_path__ + "img/bg3.a758d2b5.png";